__turbopack_context__.v({
  "root": "Wi5Jqa_root",
  "signIn": "Wi5Jqa_signIn",
  "signUp": "Wi5Jqa_signUp",
  "signUpContainer": "Wi5Jqa_signUpContainer",
});
